import { migrateV1ToV2 } from "./migrations/v01_to_v02.js";
export const CURRENT_IUM_VERSION = 2;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const migrations = [migrateV1ToV2];
// eslint-disable-next-line jsdoc/require-jsdoc
export function migrateIumIndex(index) {
    const version = index.version ?? 1;
    if (version === CURRENT_IUM_VERSION)
        return index;
    const indexMigration = version - 1;
    const migration = migrations[indexMigration];
    if (!migration)
        throw new Error(`No migration found for version ${version}`);
    const indexMigrated = migration(index);
    return migrateIumIndex(indexMigrated);
}
//# sourceMappingURL=index.js.map